import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Row, Col, Table } from 'react-bootstrap';

export default function Licitacao() {
    const { id } = useParams();
    const [licitacao, setLicitacao] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        fetch(`https://www.alepe.pe.gov.br/licitacoes/list.php?ID=${id}`).then(result => {
            result.json().then((jsonResult) => {
                setLicitacao(jsonResult.data[0]);
                setLoading(false);
            });
        });
    }, []);

    return <div>
        <p><small>Você está em <a href="/financas">Prestação de Contas</a> / <a href="/financas/licitacoes">Licitações</a> / {`${licitacao.NOMEMODALIDADE} ${licitacao.NUMEROMODALIDADE}/${licitacao.ANOPROCESSO}`}</small></p>
        <Row>
            <Col xs="12" className="text-center">
                <h2>{`${licitacao.NOMEMODALIDADE} ${licitacao.NUMEROMODALIDADE}/${licitacao.ANOPROCESSO}`}</h2>
            </Col>
            <Col xs="12" className="text-center">
                <h2 style={{ fontSize: '80%' }}>{`Processo ${licitacao.NUMEROPROCESSO}/${licitacao.ANOPROCESSO}`}</h2>
            </Col>
            <Col xs="12" className='mt-3'>
                <div className="proposicao-list-item-header">
                    <h3>Objeto conforme Edital</h3>
                </div>
                <div className="proposicao-list-item-text">
                    <p style={{ textAlign: 'justify' }}>{licitacao.OBJETOCONFORMEEDITAL}</p>
                </div>
            </Col>
            <Col xs="12" className='mt-3 mb-5 table-responsive>'>
                <h3>Informações</h3>
                <Table>
                    <tbody>
                        <tr>
                            <td><strong>STATUS:</strong></td>
                            <td style={{ minWidth: '585px' }}>{licitacao.SITUACAOLICITACAO || '-'}</td>
                        </tr>
                        <tr>
                            <td><strong>Data de Abertura:</strong></td>
                            <td style={{ minWidth: '585px' }}>
                                {licitacao.DATAEMISSAOEDITAL ? new Date(licitacao.DATAEMISSAOEDITAL.date).toLocaleDateString() : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Vencedor:</strong></td>
                            <td style={{ minWidth: '585px' }}>{licitacao.RAZAOSOCIAL || '-'}</td>
                        </tr>
                        <tr>
                            <td><strong>CPF/CNPJ:</strong></td>
                            <td>{licitacao.NUMERODOCUMENTOAJUSTADO || '-'}</td>
                        </tr>
                        <tr>
                            <td><strong>Valor Adjudicado:</strong></td>
                            <td>{licitacao.TOTALADJUDICADOLICITANTE ? `R$ ${licitacao.TOTALADJUDICADOLICITANTE.toFixed(2).replace('.', ',')}` : '-'}</td>
                        </tr>
                        <tr>
                            <td><strong>Anexos:</strong></td>
                            <td>
                                {licitacao.LinkArquivo && (
                                <a href={licitacao.LinkArquivo.replace("http://sistemas.tce.pe.gov.br/audinArquivos/licon/processo_licitatorio/edital/778/", "https://www.alepe.pe.gov.br/licitacoes/downloads/")} target="_blank" rel="noopener noreferrer">
                                    Visualizar em PDF
                                </a>
                                )}
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Col>
        </Row>
    </div>;
}